/*后台地址*/
//export const backStageUrl = 'http://ywws.leaper.ltd:41000'
export const backStageUrl = 'http://dqhongyi.leaper.ltd:41000'
/*页面地址*/
//export const pageUrl = 'http://ywws.leaper.ltd:40000'
export const pageUrl = 'http://dqhongyi.leaper.ltd:40000'
/*ERP接口地址*/
export const erpUrl = 'http://dqhongyi.leaper.ltd:38081/datasnap/rest/TServerMethods1'
